import { render, staticRenderFns } from "./ArrowDirectionRightBase.vue?vue&type=template&id=690b4d64&scoped=true&"
import script from "./ArrowDirectionRightBase.vue?vue&type=script&lang=ts&"
export * from "./ArrowDirectionRightBase.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowDirectionRightBase.vue?vue&type=style&index=0&id=690b4d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b4d64",
  null
  
)

export default component.exports